module.exports = __webpack_public_path__ + "static/media/paperwork.836a291b.png";